import * as React from "react"
import CategoryPageLayout from "../../components/categoryPageLayout"

const Upstream = ({ location }) => {
  return <CategoryPageLayout categoryId="upstream" location={location} />
}

export default Upstream
